export default __webpack_public_path__ + "static/media/search.7037bee1.svg";